export const isContactDialogOpenSelector = (state) => state.contactDialogReducer.open;
export const contactDialogDataSelector = (state) => state.contactDialogReducer.dialogData;
